import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["artifact_extractions", "suggestions"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      artifactExtractionsList: build.query<
        ArtifactExtractionsListApiResponse,
        ArtifactExtractionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/artifact-extractions/`,
          params: {
            artifact_id: queryArg.artifactId,
            extraction_type: queryArg.extractionType,
            status: queryArg.status,
          },
        }),
        providesTags: ["artifact_extractions"],
      }),
      artifactExtractionsCreate: build.mutation<
        ArtifactExtractionsCreateApiResponse,
        ArtifactExtractionsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/artifact-extractions/`,
          method: "POST",
          body: queryArg.createArtifactExtraction,
        }),
        invalidatesTags: ["artifact_extractions"],
      }),
      artifactExtractionsRetrieve: build.query<
        ArtifactExtractionsRetrieveApiResponse,
        ArtifactExtractionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/artifact-extractions/${queryArg.id}/`,
        }),
        providesTags: ["artifact_extractions"],
      }),
      artifactExtractionsUpdate: build.mutation<
        ArtifactExtractionsUpdateApiResponse,
        ArtifactExtractionsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/artifact-extractions/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.updateArtifactExtraction,
        }),
        invalidatesTags: ["artifact_extractions"],
      }),
      artifactExtractionsPartialUpdate: build.mutation<
        ArtifactExtractionsPartialUpdateApiResponse,
        ArtifactExtractionsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/artifact-extractions/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateArtifactExtraction,
        }),
        invalidatesTags: ["artifact_extractions"],
      }),
      artifactExtractionsBatchCreate: build.mutation<
        ArtifactExtractionsBatchCreateApiResponse,
        ArtifactExtractionsBatchCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/artifact-extractions/batch_create/`,
          method: "POST",
        }),
        invalidatesTags: ["artifact_extractions"],
      }),
      suggestionsList: build.query<
        SuggestionsListApiResponse,
        SuggestionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/`,
          params: {
            action: queryArg.action,
            entity_type: queryArg.entityType,
            status: queryArg.status,
            target_id: queryArg.targetId,
          },
        }),
        providesTags: ["suggestions"],
      }),
      suggestionsCreate: build.mutation<
        SuggestionsCreateApiResponse,
        SuggestionsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/`,
          method: "POST",
          body: queryArg.createSuggestion,
        }),
        invalidatesTags: ["suggestions"],
      }),
      suggestionsRetrieve: build.query<
        SuggestionsRetrieveApiResponse,
        SuggestionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/${queryArg.id}/`,
        }),
        providesTags: ["suggestions"],
      }),
      suggestionsUpdate: build.mutation<
        SuggestionsUpdateApiResponse,
        SuggestionsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.updateSuggestion,
        }),
        invalidatesTags: ["suggestions"],
      }),
      suggestionsPartialUpdate: build.mutation<
        SuggestionsPartialUpdateApiResponse,
        SuggestionsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateSuggestion,
        }),
        invalidatesTags: ["suggestions"],
      }),
      suggestionsApply: build.mutation<
        SuggestionsApplyApiResponse,
        SuggestionsApplyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/${queryArg.id}/apply/`,
          method: "POST",
        }),
        invalidatesTags: ["suggestions"],
      }),
      suggestionsExtractions: build.query<
        SuggestionsExtractionsApiResponse,
        SuggestionsExtractionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/${queryArg.id}/extractions/`,
        }),
        providesTags: ["suggestions"],
      }),
      suggestionsReject: build.mutation<
        SuggestionsRejectApiResponse,
        SuggestionsRejectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/${queryArg.id}/reject/`,
          method: "POST",
        }),
        invalidatesTags: ["suggestions"],
      }),
      suggestionsBatchCreate: build.mutation<
        SuggestionsBatchCreateApiResponse,
        SuggestionsBatchCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/suggestions/batch_create/`,
          method: "POST",
        }),
        invalidatesTags: ["suggestions"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type ArtifactExtractionsListApiResponse =
  /** status 200  */ ReadArtifactExtraction[];
export type ArtifactExtractionsListApiArg = {
  artifactId?: string;
  extractionType?: string;
  matterId: string;
  status?: string;
};
export type ArtifactExtractionsCreateApiResponse =
  /** status 201  */ ReadArtifactExtraction;
export type ArtifactExtractionsCreateApiArg = {
  matterId: string;
  createArtifactExtraction: CreateArtifactExtraction;
};
export type ArtifactExtractionsRetrieveApiResponse =
  /** status 200  */ ReadArtifactExtraction;
export type ArtifactExtractionsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type ArtifactExtractionsUpdateApiResponse =
  /** status 200  */ ReadArtifactExtraction;
export type ArtifactExtractionsUpdateApiArg = {
  id: string;
  matterId: string;
  updateArtifactExtraction: UpdateArtifactExtraction;
};
export type ArtifactExtractionsPartialUpdateApiResponse =
  /** status 200  */ ReadArtifactExtraction;
export type ArtifactExtractionsPartialUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateArtifactExtraction: UpdateArtifactExtraction2;
};
export type ArtifactExtractionsBatchCreateApiResponse =
  /** status 201  */ ReadArtifactExtraction;
export type ArtifactExtractionsBatchCreateApiArg = {
  matterId: string;
};
export type SuggestionsListApiResponse = /** status 200  */ ReadSuggestion[];
export type SuggestionsListApiArg = {
  action?: string;
  entityType?: string;
  matterId: string;
  status?: string;
  targetId?: string;
};
export type SuggestionsCreateApiResponse = /** status 201  */ ReadSuggestion;
export type SuggestionsCreateApiArg = {
  matterId: string;
  createSuggestion: CreateSuggestion;
};
export type SuggestionsRetrieveApiResponse = /** status 200  */ ReadSuggestion;
export type SuggestionsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type SuggestionsUpdateApiResponse = /** status 200  */ ReadSuggestion;
export type SuggestionsUpdateApiArg = {
  id: string;
  matterId: string;
  updateSuggestion: UpdateSuggestion;
};
export type SuggestionsPartialUpdateApiResponse =
  /** status 200  */ ReadSuggestion;
export type SuggestionsPartialUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateSuggestion: UpdateSuggestion2;
};
export type SuggestionsApplyApiResponse = /** status 200  */ ReadSuggestion;
export type SuggestionsApplyApiArg = {
  id: string;
  matterId: string;
};
export type SuggestionsExtractionsApiResponse =
  /** status 200  */ ReadArtifactExtraction;
export type SuggestionsExtractionsApiArg = {
  id: string;
  matterId: string;
};
export type SuggestionsRejectApiResponse = /** status 200  */ ReadSuggestion;
export type SuggestionsRejectApiArg = {
  id: string;
  matterId: string;
};
export type SuggestionsBatchCreateApiResponse =
  /** status 201  */ ReadSuggestion;
export type SuggestionsBatchCreateApiArg = {
  matterId: string;
};
export type ExtractionType =
  | "police_report"
  | "person"
  | "organization"
  | "vehicle"
  | "property"
  | "animal"
  | "personal_relationship"
  | "vehicle_occupancy"
  | "ownership"
  | "employment";
export type ReadExtractionCitation = {
  /** The id of the artifact/file that the citation is from. */
  artifact_id?: string | null;
  /** If there's a "citation-id" block in the text
    that corresponds to the id, reference it here. */
  citation_id?: string | null;
  /** A verbatim snippet from the text that supports the extraction.
    Include enough pre/post context to be self-explanatory. */
  excerpt?: string | null;
  extraction_id: string | string;
  block_id?: (string | string) | null;
  transcript_line_id?: (string | string) | null;
  id: string | string;
  created_at: string;
  modified_at: string;
};
export type ReadArtifactExtraction = {
  extraction_type: ExtractionType;
  extraction: any;
  extra?: any | null;
  citations: ReadExtractionCitation[];
  id: string | string;
  artifact_id: (string | string) | null;
  created_at: string;
  modified_at: string;
};
export type BaseExtractionCitation = {
  /** The id of the artifact/file that the citation is from. */
  artifact_id?: string | null;
  /** If there's a "citation-id" block in the text
    that corresponds to the id, reference it here. */
  citation_id?: string | null;
  /** A verbatim snippet from the text that supports the extraction.
    Include enough pre/post context to be self-explanatory. */
  excerpt?: string | null;
};
export type CreateArtifactExtraction = {
  extraction_type: ExtractionType;
  extraction: any;
  extra?: any | null;
  citations: BaseExtractionCitation[];
  artifact_id?: (string | string) | null;
};
export type ExtractionStatus = "active" | "orphaned";
export type UpdateArtifactExtraction = {
  id: string | string;
  status?: ExtractionStatus;
  body?: any | null;
  extra?: any | null;
};
export type UpdateArtifactExtraction2 = {
  id: string | string;
  status?: ExtractionStatus;
  body?: any | null;
  extra?: any | null;
};
export type SuggestionStatus =
  | "pending"
  | "applied"
  | "partially_applied"
  | "rejected";
export type SuggestionProvenanceStatus = "consistent" | "compromised";
export type SuggestionAction = "add_new" | "patch_existing" | "delete";
export type ReadSuggestion = {
  status: SuggestionStatus;
  provenance_status: SuggestionProvenanceStatus;
  action: SuggestionAction;
  body?: any | null;
  extraction_ids: (string | string)[];
  extra: any;
  /** The component mention IDs that should be linked to the suggestion. */
  target_id?: (string | string) | null;
  id: string | string;
  created_at: string;
  modified_at: string;
  extractions: ReadArtifactExtraction[];
};
export type CreateSuggestion = {
  action: SuggestionAction;
  extraction_type: ExtractionType;
  body: any;
  extraction_ids: (string | string)[];
  target_id?: (string | string) | null;
  extra?: any | null;
};
export type UpdateSuggestion = {
  id: string | string;
  status?: SuggestionStatus;
  body?: any | null;
  extra?: any | null;
};
export type UpdateSuggestion2 = {
  id: string | string;
  status?: SuggestionStatus;
  body?: any | null;
  extra?: any | null;
};
export const {
  useArtifactExtractionsListQuery,
  useArtifactExtractionsCreateMutation,
  useArtifactExtractionsRetrieveQuery,
  useArtifactExtractionsUpdateMutation,
  useArtifactExtractionsPartialUpdateMutation,
  useArtifactExtractionsBatchCreateMutation,
  useSuggestionsListQuery,
  useSuggestionsCreateMutation,
  useSuggestionsRetrieveQuery,
  useSuggestionsUpdateMutation,
  useSuggestionsPartialUpdateMutation,
  useSuggestionsApplyMutation,
  useSuggestionsExtractionsQuery,
  useSuggestionsRejectMutation,
  useSuggestionsBatchCreateMutation,
} = injectedRtkApi;
